import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { fromJS, Map } from 'immutable';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from '../../store/connect';
import { setViewstate, removeViewstate } from '../../actions/actionCreators';
import { color, header, breakpoint } from '../../styles/helpers/variables';

class MobileMainMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollPosition: window.pageYOffset
    };

    this.clearActiveMenuItem = this.clearActiveMenuItem.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.viewstate.get('mobileMenuActive') && nextProps.viewstate.get('mobileMenuActive')) {
      this.setState({ scrollPosition: window.pageYOffset, currentPath: this.props.location.pathname });
      if (window.pageYOffset > 0 && window.pageYOffset < header.logoAreaMobileHeight) {
        window.scrollTo(0, 0);
        this.activate(0);
      } else {
        this.activate(window.pageYOffset);
      }
    } else if (this.props.viewstate.get('mobileMenuActive') && !nextProps.viewstate.get('mobileMenuActive')) {
      if (this.state.scrollPosition > 0 && this.state.scrollPosition < header.logoAreaMobileHeight) {
        window.scrollTo(0, 0);
        this.setState(
          () => ({ scrollPosition: 0 }),
          () => {
            this.deactivate(this.state.scrollPosition);
          }
        );
      } else {
        this.deactivate(this.state.scrollPosition);
      }
    }
  }

  setActiveMenuItem(arrayOfIds) {
    this.props.setViewstate('activeMenuItem', arrayOfIds);
  }

  clearActiveMenuItem() {
    this.props.removeViewstate('activeMenuItem');
  }

  activate(scrollPosition) {
    document.body.style.position = 'fixed';
    document.body.style.left = 0;
    document.body.style.right = 0;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.overflowY = 'scroll';
  }

  deactivate(scrollPosition) {
    document.body.removeAttribute('style');
    if (this.state.currentPath === this.props.location.pathname) {
      window.scrollTo(0, scrollPosition);
    }
  }

  renderFirstLevelMenu() {
    // get sitemap object from window.sitemap
    const sitemap = this.props.sitemap.get('children', Map());

    return sitemap
      .map(item => {
        if (!item.get('visibleInMenu')) {
          return false;
        }

        // set a bool if the menu item has children and should open a submenu onClick
        const itemHasChildren = !!item
          .get('children', Map())
          .filter(itemChild => itemChild.get('visibleInMenu') === true).size;

        if (itemHasChildren) {
          return (
            <ListMenuItem key={item.get('url')} hasChildren onClick={() => this.setActiveMenuItem([item.get('id')])}>
              <MenuItem>
                <span>{item.get('title')}</span>
              </MenuItem>
            </ListMenuItem>
          );
        }

        return (
          <ListMenuItem key={item.get('url')}>
            <MenuItemLink to={item.get('url')}>
              <span>{item.get('title')}</span>
            </MenuItemLink>
          </ListMenuItem>
        );
      })
      .toArray();
  }

  renderSecondLevelMenu() {
    // don't render anything if the firstLevelMenu has not made a selection
    if (
      !this.props.viewstate.get('activeMenuItem') ||
      (this.props.viewstate.get('activeMenuItem') && this.props.viewstate.get('activeMenuItem').length < 1)
    ) {
      return false;
    }

    const parentItem = this.props.sitemap
      .get('children', Map())
      .find(item => item.get('id') === this.props.viewstate.get('activeMenuItem')[0]);

    // TODO: remove this if-statement once backend is formated correctly for CategoryLink items...
    const currentItem =
      parentItem.get('pageType', Map()) === 'CategoryLink'
        ? parentItem.getIn(['children'])
        : parentItem.get('children');

    return currentItem
      .map(item => {
        // set a bool if the menu item has children and should open a submenu onClick
        const itemHasChildren = !!item.get('children', Map()).size;

        if (itemHasChildren) {
          return (
            <ListMenuItem
              key={item.get('url')}
              isSmall
              hasChildren
              onClick={() => this.setActiveMenuItem([this.props.viewstate.get('activeMenuItem')[0], item.get('id')])}
            >
              <MenuItem isSmall>
                <span>{item.get('title')}</span>
              </MenuItem>
            </ListMenuItem>
          );
        }

        return (
          <ListMenuItem key={item.get('url')} isSmall>
            <MenuItemLinkSmall to={item.get('url')}>
              <span>{item.get('title')}</span>
            </MenuItemLinkSmall>
          </ListMenuItem>
        );
      })
      .toArray();
  }

  renderThirdLevelMenu() {
    // don't render anything if the secondLevelMenu has not made a selection
    if (
      !this.props.viewstate.get('activeMenuItem') ||
      (this.props.viewstate.get('activeMenuItem') && this.props.viewstate.get('activeMenuItem').length < 2)
    ) {
      return false;
    }

    const grandParentItem = this.props.sitemap
      .get('children', Map())
      .find(item => item.get('id') === this.props.viewstate.get('activeMenuItem')[0]);

    const parentItem =
      grandParentItem.get('pageType') === 'CategoryLink'
        ? grandParentItem
            .getIn(['children'], Map())
            .find(item => item.get('id', Map()) === this.props.viewstate.get('activeMenuItem')[1])
        : grandParentItem
            .get('children', Map())
            .find(item => item.get('id', Map()) === this.props.viewstate.get('activeMenuItem')[1]);

    // get sitemap object from window.sitemap
    const currentItem = parentItem.get('children');

    return currentItem
      .map(item => (
        <ListMenuItem key={item.get('url')} isSmall>
          <MenuItemLinkSmall to={item.get('url')}>
            <span>{item.get('title')}</span>
          </MenuItemLinkSmall>
        </ListMenuItem>
      ))
      .toArray();
  }

  renderActiveMenuItem(activeMenuItem, lastLevel = false) {
    if (!activeMenuItem) {
      return false;
    }

    let activeItem = this.props.sitemap.get('children', Map()).find(obj => obj.get('id') === activeMenuItem[0]);

    if (activeItem.get('pageType') === 'CategoryLink' && lastLevel && activeMenuItem && activeMenuItem.length > 1) {
      activeItem = activeItem.getIn(['children']).find(obj => obj.get('id') === activeMenuItem[1]);
    } else if (lastLevel && activeMenuItem && activeMenuItem.length > 1) {
      activeItem = activeItem.get('children').find(obj => obj.get('id') === activeMenuItem[1]);
    }

    return (
      <CenterDiv>
        <ActiveMenuItem to={activeItem.get('url')}>{activeItem.get('title')}</ActiveMenuItem>
      </CenterDiv>
    );
  }

  render() {
    const { viewstate } = this.props;

    const pageWidth = viewstate.get('pageWidth');
    if (pageWidth > breakpoint.large) {
      return null;
    }

    const firstLevelMenu = this.renderFirstLevelMenu();
    const secondLevelMenu = this.renderSecondLevelMenu();
    const thirdLevelMenu = this.renderThirdLevelMenu();
    const secondLevelactiveMenuItem = this.renderActiveMenuItem(viewstate.get('activeMenuItem'));
    const thirdLevelactiveMenuItem = this.renderActiveMenuItem(viewstate.get('activeMenuItem'), true);

    return (
      <MobileMenuContainer active={viewstate.get('mobileMenuActive')}>
        <BackAndClose
          active={viewstate.get('mobileMenuActive')}
          onClick={() => {
            if (viewstate.get('activeMenuItem')) {
              if (viewstate.get('activeMenuItem').length > 1) {
                this.props.setViewstate('activeMenuItem', viewstate.get('activeMenuItem').slice(0, -1));
              } else {
                this.props.removeViewstate('activeMenuItem');
              }
            } else {
              this.props.removeViewstate('mobileMenuActive');
            }
          }}
        >
          {viewstate.get('activeMenuItem') ? 'Tillbaka' : 'Stäng'}
        </BackAndClose>
        <SlideInContainer className="SlideInContainer" active={viewstate.get('mobileMenuActive')}>
          <SubMenuList>{firstLevelMenu}</SubMenuList>
        </SlideInContainer>
        <SlideInContainer
          className="SlideInContainer"
          active={
            viewstate.get('mobileMenuActive') &&
            viewstate.get('activeMenuItem') &&
            viewstate.get('activeMenuItem').length >= 1
          }
        >
          {secondLevelactiveMenuItem}
          <SubMenuList>{secondLevelMenu}</SubMenuList>
        </SlideInContainer>
        <SlideInContainer
          className="SlideInContainer"
          active={
            viewstate.get('mobileMenuActive') &&
            viewstate.get('activeMenuItem') &&
            viewstate.get('activeMenuItem').length >= 2
          }
        >
          {thirdLevelactiveMenuItem}
          <SubMenuList>{thirdLevelMenu}</SubMenuList>
        </SlideInContainer>
      </MobileMenuContainer>
    );
  }
}

const BackAndClose = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 11.5px 20px;
  border: none;
  outline: none;
  border-top: 1px solid #333333;
  border-bottom: 1px solid #333333;
  background-color: ${color.black};
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 0.125em;
  text-transform: uppercase;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  transform: translateX(-100%);
  transition: transform 0.25s ease-out, color 0.25s ease-out;
  cursor: pointer;
  ${props =>
    props.active &&
    css`
      transform: translateX(0);
    `};
  &:hover {
    color: rgba(255, 255, 255, 0.625);
  }
  &:active {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const MobileMenuContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  height: calc(100vh - 100%);
  width: 100%;
  overflow: hidden;
  visibility: hidden;
  z-index: 1;
  transition: visibility 0s linear 0.25s;
  ${props =>
    props.active &&
    css`
      visibility: visible;
      transition: visibility 0s linear 0s;
    `};
`;

const SlideInContainer = styled.div`
  position: absolute;
  top: 40px;
  right: -5px;
  bottom: 0;
  left: 0;
  padding: 0 0 25px;
  transform: translateX(-100%);
  background-color: ${color.black};
  transition: transform 0.25s ease-out;
  border-right: 5px solid ${color.darkerGrey};
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  ${props =>
    props.active &&
    css`
      transform: translateX(0);
    `};
`;

const CenterDiv = styled.div`
  padding-top: 30px;
  text-align: center;
`;

const ActiveMenuItem = styled(Link)`
  font-size: 19px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  text-decoration: none;
  padding: 20px 0;
  color: #ffffff;
  transition: opacity 250ms ease-out;

  &:hover {
    opacity: 0.8;
  }
`;

const SubMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  z-index: 100;
  padding: 20px 0 0;
  background-color: white;
  color: ${color.black};
`;

const SubMenuList = styled.ul`
  margin: 0;
  padding: 20px 0;
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const MenuItem = styled.p`
  font-size: 19px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${color.white};
  text-decoration: none;
  padding: 10px;
  margin: 0;
  cursor: pointer;
`;

const MenuItemSmall = styled.p`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${color.white};
  text-decoration: none;
  padding: 10px;
  margin: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.3px;
  text-transform: uppercase;
`;

const MenuItemLink = MenuItem.withComponent(Link);
const MenuItemLinkSmall = MenuItemSmall.withComponent(Link);

const ListMenuItem = styled.li`
  color: ${color.white};
  border-top: 1px solid transparent;
  transition: opacity 250ms ease-out;

  &:hover {
    span {
      opacity: 0.8;
    }

    ${SubMenu} {
      opacity: 1;
      transform: translateY(0);
    }
  }

  ${props =>
    props.hasChildren &&
    css`
      span:after {
        content: '';
        background-image: url('/images/icons/arrow-white.svg');
        background-size: contain;
        background-repeat: no-repeat;
        min-width: 10px;
        height: 10px;
        display: inline-block;
        margin-left: 6px;
        transform: rotateZ(-90deg);
      }
    `};

  ${props =>
    props.isSmall &&
    css`
      span:after {
        min-width: 7px;
        height: 7px;
        margin-bottom: 1px;
      }
    `};
`;

MobileMainMenu.defaultProps = {
  viewstate: Map(),
  sitemap: Map()
};

MobileMainMenu.propTypes = {
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  sitemap: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired
};

export default connect(MobileMainMenu, { setViewstate, removeViewstate }, store => ({
  viewstate: store.viewstate,
  sitemap: fromJS(window.sitemap)
}));



// WEBPACK FOOTER //
// ./src/components/Header/MobileMainMenu.js